module.exports = {"510821100":"东河镇","510821101":"嘉川镇","510821102":"木门镇","510821103":"白水镇","510821105":"张华镇","510821106":"黄洋镇","510821107":"普济镇","510821108":"三江镇","510821110":"五权镇","510821111":"高阳镇","510821112":"双汇镇","510821113":"英萃镇","510821114":"国华镇","510821115":"龙凤镇","510821116":"九龙镇","510821117":"米仓山镇","510821118":"大德镇","510821119":"大两镇","510821120":"水磨镇","510821121":"盐河镇","510821122":"天星镇","510821204":"燕子乡","510821207":"檬子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510821.json
// module id = 2443
// module chunks = 0